import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const MenuService = {
  getMenusList(){ return axiosRequest('POST', API_PATH.MENU.LIST) },
  addMenu(data){ return axiosRequest('POST', API_PATH.MENU.ADD, data) },
  deleteMenu(params){ return axiosRequest('POST', API_PATH.MENU.DELETE(params)) },
  getAccessGroupsList(data){ return axiosRequest('POST', API_PATH.MENU.ACCESS_GROUP_LIST, data) },

}